.card {
  background: var(--static-background-strong);
  border-radius: 14px;
  outline: 1px solid var(--static-divider-standard);
  margin: 3px;
  transition: outline-color 100ms ease-out;
}
:global(body:not(.amDraggingNDroppingGiveCursor)) .card.active {
  outline-color: var(--color-primary);
  outline-width: 2px;
}

/* @NOTE(michaelp): Black and white when dragging-and-dropping */
:global(body.amDraggingNDroppingGiveCursor) .card.active {
  outline-width: 1px;
  outline-color: var(--static-divider-standard);
}
:global(body.amDraggingNDroppingGiveCursor) .card input[type="checkbox"] {
  accent-color: #6f6f6f;
}
/* @NOTE(michaelp): Active when dragging-and-dropping */
.card.boxHoveringWhenDragging {
  outline-color: var(--color-primary) !important;
  outline-width: 2px !important;
}


.card.disabled {
  filter: grayscale();
  opacity: 0.7;
}
.accordion {
  transition: height 300ms;
  overflow: hidden;
}
.content {
  padding: 13px 15px;
}


/* the wrapper is necessary because if we put padding directly
on the card's child then the accordion won't collapse properly */
.contentWrapper {
  border-top: 1px none var(--static-divider-standard);
}
.contentWrapper.borderBottomSolid + .contentWrapper,
.contentWrapper.borderBottomSolid + .accordion > .contentWrapper {
  border-top-style: solid;
}
.contentWrapper.borderBottomDashed + .contentWrapper,
.contentWrapper.borderBottomDashed + .accordion > .contentWrapper {
  border-top-style: dashed;
}
/* these need to come after the borderBottom styles to override them */
.contentWrapper.borderTopSolid:not(:first-child),
.accordion:not(:first-child) .contentWrapper.borderTopSolid {
  border-top-style: solid;
}
.contentWrapper.borderTopDashed:not(:first-child),
.accordion:not(:first-child) .contentWrapper.borderTopDashed {
  border-top-style: dashed;
}
